function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  fontFamily: "material",
  fontSize: 30,
  fontWeight: "normal"
}, React.createElement("g", {
  id: "Shopping-Cart",
  transform: "translate(-1261.000000, -363.000000)",
  fill: "#000000"
}, React.createElement("g", {
  id: "Cart",
  transform: "translate(134.000000, 308.000000)"
}, React.createElement("g", {
  id: "Product-Lines"
}, React.createElement("g", {
  id: "Product-1-Line",
  transform: "translate(15.000000, 0.000000)"
}, React.createElement("text", {
  id: "close---material"
}, React.createElement("tspan", {
  x: 1106,
  y: 75
}, "\uE88F")))))));

var SvgCloseBtn = function SvgCloseBtn(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloseBtn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/closeBtn.cff50ffb.svg";
export { ForwardRef as ReactComponent };